module.exports = __webpack_public_path__ + "media/maps-markers/blue-pin-254d9dc9.svg";